// Application settings. Placed here to be able downloaded from the server in future
import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    system: {
        // PROD по умолчанию (yarn build). `yarn build:dev` подставляет DEV-сервер
        // через переменную REACT_APP_SERVER (см. package.json).
        server: process.env.REACT_APP_SERVER || 'https://www.amfy.app',
    },
    user: {
        locale: 'en',
        city: null,
        firstWeekDay: 'sunday',  //'monday'
        timeFormat: '24H',
        dateFormat: 'ISO',
        dateSeparator: '-',
        // PUSH: true,
        // EMAIL: true,
        // SMS: true,
    },
    person: {},
    ui: {
        appbarSize: 0,
    }
};

export const settingsSlice = createSlice({
    name: 'settings',
    initialState,
    reducers: {
        modifySettings: (state, action) => {
            for (let settingType in action.payload) {
                state[settingType] = {...state[settingType], ...action.payload[settingType]};
            }
        },
        setSystemSettings: (state, action) => {
            state.system = action.payload;
        },
        setUserSettings: (state, action) => {
            state.user = action.payload;
        },
        setPersonSettings: (state, action) => {
            state.person = action.payload;
        },
        setLocale: (state, action) => {
            state.user.locale = action.payload;
        },
        setCity: (state, action) => {
            state.user.city = action.payload;
        },
        setFirstWeekDay: (state, action) => {
            state.user.firstWeekDay = action.payload;
        },
        setTimeformat: (state, action) => {
            state.user.timeFormat = action.payload;
        },
        setDateFormat: (state, action) => {
            state.user.dateFormat = action.payload;
        },
        setDateSeparator: (state, action) => {
            state.user.dateSeparator = action.payload;
        },
        setPushNotification: (state, action) => {
            state.user.PUSH = action.payload;
        },
        setEmailNotification: (state, action) => {
            state.user.EMAIL = action.payload;
        },
        setSmsNotification: (state, action) => {
            state.user.SMS = action.payload;
        },
        setAppbarSize: (state, action) => {
            state.ui.appbarSize = action.payload;
        },
    },
});

export const {
    modifySettings,
    setSystemSettings,
    setUserSettings,
    setLocale,
    setCity,
    setFirstWeekDay,
    setTimeformat,
    setDateFormat,
    setDateSeparator,
    setAppbarSize,
    setEmailNotification,
    setPushNotification,
    setSmsNotification,
    setPersonSettings
} = settingsSlice.actions;

export const getSystemSettings = (state) => state.settings.system;
export const getUserSettings = (state) => state.settings.user;
export const getPersonSettings = (state) => state.settings.person;
export const getAppbarSize = (state) => state.settings.ui.appbarSize;

export default settingsSlice.reducer;